import { useStaticQuery, graphql } from 'gatsby'

export function getAuthor(authors, name) {
  const authorSet = authors.reduce(
    (accumulator, currentValue) => accumulator.concat(currentValue.node),
    []
  )

  // Find author by key
  let matchedAuthor = authorSet.find(
    (author) => author.frontmatter.title === name
  )

  if (!matchedAuthor) {
    // If no author is found, set to default
    matchedAuthor = authorSet.find(
      (author) => author.frontmatter.title === 'Gremlin'
    )
  }

  // If for some reason we still didn't find an appropriate mached author; bail
  if (!matchedAuthor) return null

  return matchedAuthor
}

const useAuthor = (name) => {
  const {
    allMdx: { edges: authorEdges },
  } = useStaticQuery(graphql`
    query AuthorPageData {
      allMdx(filter: { fileAbsolutePath: { regex: "/meta/people/" } }) {
        edges {
          node {
            frontmatter {
              title
              position
              photo
            }
          }
        }
      }
    }
  `)

  // If name is not supplied; we want everything
  if (!name) return authorEdges

  return getAuthor(authorEdges, name)
}

export default useAuthor
